<script>
  import ResultsTable from './ResultsTable.svelte';

  /** @type {import('../types.d').ReadableRace} */
  export let feed;

  /** @type {boolean} */
  export let face = false;

  /** @type {import('../types.d').Crosswalk | null} */
  export let crosswalk = null;

  /** @type {string | undefined} */
  export let captionNote = undefined;

  /** @type {boolean} */
  export let shouldSortCandidates = false;

  /** @type {boolean} */
  export let showCaption = true;

  /** @type {boolean} */
  export let hidePrecincts = false;

  /** @type {boolean} */
  export let filterNoVotes = false;

  /** @type {string} */
  export let componentRaceType = '';

  $: race = feed;
  $: caption = showCaption && !['G', 'T', 'L'].includes($race.race_type)
    ? $race.seat_name
    : '';

  $: aboveThreshold = $race.candidates.filter(c => $race.total_votes > 0 && c.votes / $race.total_votes >= 0.01);
  $: shouldFilter = filterNoVotes && $race.eevp !== null && $race.eevp >= 20;

  $: displayCandidates = shouldFilter ? aboveThreshold : $race.candidates;

  $: noVoteNames = shouldFilter
    ? $race.candidates.filter(c => !aboveThreshold.includes(c)).map(c => `${c.given_name} ${c.family_name}`)
    : [];

  $: noVoteNote = noVoteNames.length > 0
    ? `* Candidates receiving less than 1% of the total vote are not listed.`
    : '';

  $: resolvedCaptionNote = captionNote !== undefined ? captionNote : $race.description;
</script>

<ResultsTable
  {face}
  {crosswalk}
  {caption}
  raceId={$race.id}
  captionNote={resolvedCaptionNote}
  candidates={displayCandidates}
  totalVotes={$race.total_votes}
  office={$race.office}
  raceType={$race.race_type}
  precinctsReportingPercent={$race.precincts_reporting_percent}
  eevp={$race.eevp}
  numOfwinners={$race.number_of_winners}
  {shouldSortCandidates}
  {hidePrecincts}
  expandLabel={shouldFilter ? 'more' : 'all'}
  {noVoteNote}
  {componentRaceType}
/>

